export default "__VITE_ASSET__CpLdX2Rc__"